<template>
    <multiselect class="multiselect-primary"
                 :value="model"
                 v-model="dataVal"
                 @input="inputDefault"
                 :options="options"
                 width="100%"
                 :required="required"
                 :disabled="disabled"
                 :label="text"
                 :track-by="trackBy"
                 :placeholder="placeholder"
                 :selectLabel="selectLabel"
                 :selectedLabel="selectedLabel"
                 :deselectLabel="deselectLabel"
                 :noResult="noResult"
                 :showNoResults="showNoResults"
                 @search-change="search"
                 >
        <span slot="noOptions">{{noResult}}</span>
    </multiselect>
</template>

<script>
export default {
  props: {
    value: null,
    input: { type: Function, default: null },
    options: { type: Array, default () { return [] } },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    single: { type: Boolean, default: false },
    text: { default: 'text' },
    trackBy: { default: 'value' },
    placeholder: { default: 'Selecione' },
    selectLabel: { default: '' },
    selectedLabel: { default: '' },
    deselectLabel: { default: '' },
    noResult: { default: 'Sem Resultados' },
    showNoResults: { type: Boolean, default: false },
    search: { type: Function, default () { return false } }
  },
  data () {
    return {
      dataVal: null
    }
  },
  computed: {
    model: {
      get () {
        var obj = this.value
        if (this.single && (obj || obj === 0)) {
          obj = this.options.find(x => x[this.trackBy].toString() === obj.toString())
        }
        this.dataVal = obj
        return obj
      },
      set (val) {
        var obj = val
        if (this.single) {
          obj = val[this.trackBy]
        }
        this.dataVal = obj
      }
    }
  },
  methods: {
    inputDefault: function (val) {
      this.$nextTick(function () {
        if (this.$el) {
          var input = this.$el.querySelector('input.multiselect__input')
          input.setAttribute('value', val && val[this.trackBy] ? val[this.trackBy] : '')
        }
      })

      if (val || val === 0) {
        if (val[this.trackBy]) { this.$el.querySelectorAll('.multiselect .multiselect__tags input').forEach(p => p.setAttribute('value', val[this.trackBy])) } else { this.$el.querySelectorAll('.multiselect .multiselect__tags input').forEach(p => p.value = null) }
      }

      if (!this.single) { this.$emit('input', val) } else {
        this.$emit('input', val ? val[this.trackBy] : null)
      }

      if (val != this.model) {
        if (this.input) { this.input(val) }
      }
    }
  },
  watch: {
    model: function (newValue, oldValue) {
      this.inputDefault(newValue)
    }
  },
  directives: {
    'select-overflow': {
      inserted: (el, _binding, vnode) => {
        // setTimeout(function () {
        //    var element = el.getElementsByClassName("multiselect__content-wrapper")[0]
        //    element.style.position = 'absolute'
        //    element.style.width = "inherit"
        // }, 10)
      }
    }
  }
}
</script>
